import cn from 'classnames/bind';

import s from './Badge.module.scss';

const cx = cn.bind(s);

const Badge = ({
  children, isText = false, size, count,
}) => (
  <div className={cx('badge', size, { textBadge: isText })}>
    { children }
    { count ? <span className={cx('counter')}><span className={cx('counterInner')}>{count}</span></span> : null}
  </div>
);

export default Badge;
